import React from 'react';
import { useController, ApplicationView as view } from '@aha-app/mvc';
import { SelectroController } from '@aha-app/selectro-v2';
import UserAvatar from './components/UserAvatar';
import { resolveAttribute } from '../helpers';

interface UserTriggerItemsProps {
  // To have more control over the items displayed, we can pass items directly.
  items?: {
    value: any;
    text?: string;
    label?: string;
    avatar: string;
    initials: string;
  }[];
}

const UserTriggerItems: React.FC<UserTriggerItemsProps> = ({ items }) => {
  const controller = useController(SelectroController);
  const { selectedItems, state } = controller;
  const onlyAvatars = selectedItems.length > 3;
  const multiple = !controller.isSingleSelect;
  const triggerItems = items || selectedItems;

  const handleRemove = (e, item: any) => {
    e.preventDefault();
    const newSelection = controller.selected.filter(
      selectedItem => selectedItem.value !== item.value
    );
    controller.actionSetSelected(newSelection);
    // When removing an item, it's important to call the selectro-v2 select
    // callback so react-in-place or any other component can react to the change and persist it.
    controller.callSelectCallback({
      item,
      // By default, react-in-place does not persist changes immediately on select,
      // this tells it to do so the moment a user clicks on the remove icon.
      persistChange: true,
    });
  };

  if (!triggerItems?.length) {
    return <span>{state.text.noneSelected}</span>;
  }

  return (
    <div className='tw-flex tw-gap-1 tw-items-start'>
      {controller?.state && state.text?.preScript && (
        <span>{state.text.preScript}</span>
      )}
      <div className='tw-flex tw-items-center tw-gap-1 tw-flex-wrap'>
        {triggerItems.map(item => (
          <UserAvatar
            onRemove={event => handleRemove(event, item)}
            key={item.value}
            avatar={resolveAttribute(item, 'avatar')}
            text={
              resolveAttribute(item, 'text') || resolveAttribute(item, 'label')
            }
            multiple={multiple}
            initials={resolveAttribute(item, 'initials')}
            onlyAvatar={onlyAvatars}
          />
        ))}
      </div>
    </div>
  );
};

export default view(UserTriggerItems);
